<template>
  <Primitive
    :as="as"
    :as-child="asChild"
    :class="cn('flex gap-2', buttonVariants({ variant, size }), props.class)"
    :disabled="loading"
  >
    <slot
      v-if="loading"
      name="loading"
    >
      <Loader2 class="size-4 animate-spin" /> {{ loadingText || t('common.pleaseWait') }}
    </slot>

    <slot
      v-if="!loading"
      name="beforeIcon"
    ></slot>
    <slot v-if="!loading || !onlyIcon"></slot>
    <slot
      v-if="!onlyIcon"
      name="afterIcon"
    ></slot>
  </Primitive>
</template>

<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { useI18n } from 'vue-i18n'

import { Loader2 } from 'lucide-vue-next'
import { Primitive, type PrimitiveProps } from 'reka-ui'

import { cn } from '@/lib/utils'

import { type ButtonVariants, buttonVariants } from '.'

const { t } = useI18n()

interface Props extends PrimitiveProps {
  variant?: ButtonVariants['variant']
  size?: ButtonVariants['size']
  class?: HTMLAttributes['class']
  loading?: boolean
  loadingText?: string
  onlyIcon?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  as: 'button',
  asChild: false,
  onlyIcon: false,
})
</script>
